import React, { Component } from 'react'
import { connect } from 'react-redux'
import TbForm from './tb_form'
import TbListFilter from './tbListFilter'
import * as actions from '../../actions'
// import { reduxForm, Field } from 'redux-form'
// import { renderTextField, renderCheckbox, renderSelectField } from '../auth/form_helpers'
// import MenuItem from 'material-ui/MenuItem';
// import Paper from 'material-ui/Paper';
import {List, ListItem} from 'material-ui/List';
import AVNote from 'material-ui/svg-icons/av/note';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton'
import {lightBlack, darkBlack} from 'material-ui/styles/colors';
import Dialog from 'material-ui/Dialog';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import AppBar from 'material-ui/AppBar';
import Waypoint from 'react-waypoint';

var FileSaver = require('file-saver');

var jsonpatch = require('fast-json-patch')
const uuidv4 = require('uuid/v4');
var params = '?';
var hasEdited = false;
var patchresponsed = true;

const styles = {
  m15: {
    margin: 15,
  },
  customContentStyle: {
    width: '100%',
    maxWidth: 'none',
  },
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  plusButton: {
    position: "fixed",
    right: 20,
    bottom: 20,
    zIndex: 1,
  }
};

var shouldSave = true;
var closeRequest = null;

class Tb extends Component {

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.authError(null)
    }
    closeRequest = null
  }

  componentWillMount() {
    this.props.fetchMessage('/affairs', '?offset=0&limit=50');
    this.props.getEnums('/dev.enum/affair-categories', '?detailed', 'AffairCategories');
    this.props.getEnums('/dev.enum/affair-status', '?detailed', 'AffairStatus');
    this.props.getEnums('/dev.enum/affair-automated', '?detailed', 'AffairAutomated');
    // this.props.getEnums('/stats/group-amounts', '?by=year', 'GroupsByYear'); // Filter : year
  }

  componentDidMount() {
    var that = this
    closeRequest = function() {
      window.onbeforeunload = function() {
        that.setState({iscloserequest: true});
        that.handleFakeSubmit(false)
        if (that.state.openedform) {
          if (!that.state.isemptyonclose) {
            that.setState({iscloserequest: false});
            return 'You have unsaved changes!';
          }

        }
      }
    }
    closeRequest()
    let actualHref = window.location.href;
    if ( actualHref.substring(actualHref.length - 3).indexOf('tb') === -1 ) {
      let affairId = actualHref.substring((actualHref.indexOf('tb') + 3))
      window.history.pushState({"html":document.documentElement.innerHTML,"pageTitle":document.title},"", actualHref.substring( 0, (actualHref.indexOf('tb') + 3) ));
      this.props.openAffair('', affairId, '', '');
      this.setState({open: true});
      this.setState({openedform: true});
    }
  }

  state = {
    open: false,
    openedform: false,
    iscloserequest: false,
    isemptyonclose: false,
    filterparams: "?",
  }

  openReferedTb = () => {
  }

  handleOpen = ( val, target, name ) => {
    this.props.openAffair('/affairs', '/'+val, target, name);
    this.setState({open: true});
    this.setState({openedform: true});
  }

  handleNewOpen = ( val ) => {
    this.props.openAffair('/affairs', val, null, null);
    this.setState({open: true});
    this.setState({openedform: true});
  }

  handleClose = () => {
    this.handleFakeSubmit(false);
    //if (hasEdited) {
    //  if (confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.')) {
    //    this.props.closeAffair()
    //    this.props.fetchMessage('/affairs', params);
    //    this.setState({open: false});
    //  }
    //} else {
    //  this.props.closeAffair()
    //  this.props.fetchMessage('/affairs', params);
    //  this.setState({open: false});
    //}
    //this.props.closeAffair()
    //this.props.fetchMessage('/affairs', params);
    //this.setState({open: false});
  }

  handleSubmit({id, idPersonNew, idNewId, item, subject, history, historynew, comments, resolution, commentsnew, notification, creation}) {
    let patchArrayCounter = 0;
    patchresponsed = true
    let patchArray = []
    let loadedAffair = this.props.thisaffair;
    let personId;
    if (typeof idNewId !== 'undefined') {
      personId = idNewId
    } else {
      personId = item
    }
    let dateString;
    if (typeof notification !== 'undefined' && notification !== null) {
      if(notification.length === 10) {
        dateString = notification;
      } else {
        console.log(notification)
        if(typeof notification === 'string'){notification = new Date(notification)}
        notification.setMinutes(notification.getMinutes() - notification.getTimezoneOffset());
        // dateString = notification.toLocaleDateString('hu-HU').replace(/[\.]/g, '-').replace(/[' ']/g, '').replace(/\-$/, '')
        dateString = notification.toISOString().slice(0,10)
      }
    }
    let dateString2;
    if (typeof creation !== 'undefined' && creation !== null) {
      if(creation.length === 10) {
        dateString2 = creation;
      } else {
        if(typeof creation === 'string'){creation = new Date(creation)}
        creation.setMinutes(creation.getMinutes() - creation.getTimezoneOffset());
        //dateString2 = creation.toLocaleDateString('hu-HU').replace(/[\.]/g, '-').replace(/[' ']/g, '').replace(/\-$/, '')
        dateString2 = creation.toISOString().slice(0,10)
      }
    }

    let commentss = [];
    if (typeof comments !== "undefined") {
      comments.forEach(function(item, index){
        if(item.text !== null) {
          let itemtime = loadedAffair.comments[index].time
          commentss.push({"text" : item.text,"time" : itemtime});
        }
      })
    }
    if (typeof commentsnew !== "undefined") {
      let itIsNow = new Date();
      commentss.push({"text" : commentsnew.text})
    }

    let historyy = [];
    if (typeof history !== "undefined") {
      history.forEach(function(item, index){
        //let itemtime = loadedAffair.history[index].date
        let itIsTheTime = new Date(item.date)
        itIsTheTime.setMinutes(itIsTheTime.getMinutes() - itIsTheTime.getTimezoneOffset()); // itIsTheTime.toISOString().slice(0,10)
        // historyy.push({"status" : item.status,"date" : itIsTheTime.toLocaleDateString('hu-HU').replace(/[.]/g, '-').replace(/[' ']/g, '').replace(/-$/, '').substring(0,10) });
        historyy.push({"status" : item.status,"date" :  itIsTheTime.toISOString().slice(0,10) });
      })
    }
    if (typeof historynew !== "undefined") {
      let itIsNow = new Date();
        itIsNow.setMinutes(itIsNow.getMinutes() - itIsNow.getTimezoneOffset()); // itIsNow.toISOString().slice(0,10)
      // historyy.push({"status" : historynew.status, "date" : itIsNow.toLocaleDateString('hu-HU').replace(/[\.]/g, '-').replace(/[' ']/g, '').replace(/\-$/, '') })
      historyy.push({"status" : historynew.status, "date" : itIsNow.toISOString().slice(0,10) })
    }

    let loaded = {
      "id" : loadedAffair.id,
      // "subject": loadedAffair.subject,
      // "resolution": loadedAffair.resolution,
      // "notification":loadedAffair.notification,
      "creation":loadedAffair.creation,
      "comments":loadedAffair.comments,
      "history":loadedAffair.history
    }
    if (typeof loadedAffair.resolution !== 'undefined') {
      loaded.resolution = loadedAffair.resolution
    }
    if (typeof loadedAffair.notification !== 'undefined') {
      loaded.notification = loadedAffair.notification
    }
    if (typeof loadedAffair.subject !== 'undefined') {
      loaded.subject = loadedAffair.subject;
    }

    let edited = {
      "id" : id,
      "subject": subject,
      "resolution": resolution,
      "notification": dateString,
      "creation": dateString2,
      "comments" : commentss,
      "history" : historyy
    }
    // edited.name = loadedAffair.name
    // edited.item = loadedAffair.item
    // delete loadedAffair.name;
    // delete loadedAffair.item;
    var patch = jsonpatch.compare(loaded, edited)

    patchArray.push({
      endpoint: '/persons/'+personId+'/affairs',
      params: '/'+id,
      patchvar: patch,
      needalert: false
    })
    let propsforpatch = this.props;
    let that = this;
    let cntrObj = {}
    cntrObj.lngt = patchArray.length;
    function patcher(maybeSave) {
      if (typeof maybeSave !== 'undefined' && maybeSave === true) {
        if (patchresponsed === true) {
          if (patchArray.length === patchArrayCounter) {
            // All PATCH done
            propsforpatch.fetchMessage('/affairs', params); // refresh list
            hasEdited = false;
            propsforpatch.openAffair('/affairs', '/'+id, personId, loadedAffair.name);
            alert('Sikeres módosítás')
            patcher = null
          } else {
            document.getElementsByTagName("body")[0].addEventListener('patchresponse'+patchArrayCounter, function (e) {
              // we have response
              patchresponsed = true
              patchArrayCounter++
              if (patcher !== null) {
                patcher(shouldSave);
              }
            }, false)
            if (typeof patchArray[patchArrayCounter] !== 'undefined' && typeof patchArray[patchArrayCounter].del !== 'undefined' && patchArray[patchArrayCounter].del === true) {
              propsforpatch.deleteParticipant(patchArray[patchArrayCounter].endpoint, patchArray[patchArrayCounter].params, patchArrayCounter)
            } else {
              propsforpatch.patchItem(patchArray[patchArrayCounter].endpoint, patchArray[patchArrayCounter].params, patchArray[patchArrayCounter].patchvar, patchArray[patchArrayCounter].needalert, patchArrayCounter)
            }
            patchresponsed = false
          }
        }

      } else {
        if (that.state.iscloserequest) { // EZ LETT BERAKVA
          let isEmpty = true
          patchArray.map((option, index) => {
            if (option.patchvar.length > 0) {
              isEmpty = false
            }
          })
          if (isEmpty) {
            that.setState({isemptyonclose : true})
            return true
          } else {
            that.setState({isemptyonclose : false})
            return false
          }
        } else {
          let isEmpty = true
          patchArray.map((option, index) => {
            if (option.patchvar.length > 0) {
              isEmpty = false
            }
          })
          if (isEmpty) {
            propsforpatch.closeAffair()
            propsforpatch.fetchMessage('/affairs', params);
            that.setState({open: false});
            that.setState({openedform: false});
          } else {
            if (window.confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.\n\nBezárjuk a form-ot?')) {
            propsforpatch.closeAffair()
            propsforpatch.fetchMessage('/affairs', params);
            that.setState({open: false});
            that.setState({openedform: false});
            }
          }
        }

      }
    }
    patcher(shouldSave);
    /*
      if (shouldSave === true) {
          this.props.patchItem('/persons/'+personId+'/affairs', '/'+id, patch)
          loadedAffair.item = personId;
          this.props.fetchMessage('/affairs', params);
          hasEdited = false;
          this.props.openAffair('/affairs', '/'+id, personId, loadedAffair.name);
      } else {
        if (patch.length > 0) {
          if (confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.\n\nBezárjuk a form-ot?')) {
            this.props.closeAffair()
            this.props.fetchMessage('/affairs', params);
            this.setState({open: false});
          }
        } else {
          this.props.closeAffair()
          this.props.fetchMessage('/affairs', params);
          this.setState({open: false});
        }
      }
    */
  }

  scrollTo = (element, to, duration) => {
      //t = current time
      //b = start value
      //c = change in value
      //d = duration
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      var start = element.scrollTop,
          change = to - start,
          currentTime = 0,
          increment = 20;
          
      var animateScroll = function(){        
          currentTime += increment;
          var val = Math.easeInOutQuad(currentTime, start, change, duration);
          element.scrollTop = val;
          if(currentTime < duration) {
              setTimeout(animateScroll, increment);
          }
      };
      animateScroll();
  }

  handleFilter({query, year, category, automated}) {
    params = '?';
    if (typeof query !== 'undefined') {
      params = params + '&q='+query
    }
    if (typeof category !== 'undefined') {
      params = params + '&category='+category
    }
    if (typeof year !== 'undefined' && year !== 'all') {
      params = params + '&year='+year
    }
    if (typeof automated !== 'undefined') {
      params = params + '&automated='+automated
    }
    // console.log(params)
    window.scrollTo(document.body, 0, 1250);
    this.setState({filterparams: params});
    this.props.fetchMessage('/affairs', params);
  }

  handleFakeSubmit = (should) => {
    // let classes = document.getElementsByClassName('PersonFormSubmitButton');
    // let Rate = classes[0];
    // let Btn = Rate.getElementsByTagName('button')[0];
    // Btn.click();
    if (should === false) {
      shouldSave = false;
      let classes = document.getElementsByClassName('PersonFormSubmitButton');
      if (typeof classes !== 'undefined' && classes.length > 0) {
        let Rate = classes[0];
        let Btn = Rate.getElementsByTagName('button')[0];
        Btn.click();
      } else {
        this.setState({open: false});
      }
    } else {
      shouldSave = true;
      let classes = document.getElementsByClassName('PersonFormSubmitButton');
      if (typeof classes !== 'undefined' && classes.length > 0) {
        let Rate = classes[0];
        let Btn = Rate.getElementsByTagName('button')[0];
        Btn.click();
      } else {
        this.setState({open: false});
      }
    }
  }
  
  csvExport = () => {
    let d = new Date();
    let t = d.getTime();
    let fullparam = '?'
    if (typeof this.state.filterparams !== 'undefined' && this.state.filterparams !== '') {
      if (this.state.filterparams.indexOf('?') > -1) {
        fullparam = this.state.filterparams+'&t='+t
      } else {
        fullparam = '?'+this.state.filterparams+'&t='+t
      }
    } else {
      fullparam = fullparam+'t='+t
    }
    var request = new XMLHttpRequest();
    request.open('GET', 'https://admin.magyarpszichodrama.hu/api/v1.0/affairs.csv'+fullparam);
    request.responseType = 'blob';
    request.setRequestHeader('X-Auth-Token', localStorage.getItem('token'));
    var blob;
    request.onload = function() {
      blob = request.response;
      FileSaver.saveAs(blob, "tb.csv");
    };
    request.send();
  }

  render() {
    //this.openReferedTb()
    if(typeof this.props.message !== 'undefined') {
      // console.log(JSON.parse(this.props.thisperson))
      let uu = uuidv4();
      return (
        <div style={{paddingBottom: 351}}>
          <AppBar
            title="TB ügyek"
          />
          <Dialog
            // title="Személy szerkesztése"
            actions={[
              <RaisedButton label='Mentés' onTouchTap={ this.handleFakeSubmit } primary={true} />,
              <FlatButton label='Bezár' onTouchTap={ this.handleClose } />
            ]}
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose}
            autoScrollBodyContent={true}
            contentStyle={styles.customContentStyle}
          >
            <TbForm
              handleClose={this.handleClose.bind(this)}
              onSubmit={this.handleSubmit.bind(this)}
              errorMessage={this.props.errorMessage}
              affairinfos={this.props.thisaffair}
              editinfos={this.props.editedaffair}
              tracker={this.props.tracker}
              autocomplete={this.props.autocomplete}
              affaircategories={this.props.affaircategories}
              affairstatus={this.props.affairstatus}
              fetchMessage={this.props.fetchMessage}
            />
          </Dialog>
          <TbListFilter
            affaircategories={this.props.affaircategories}
            affairautomated={this.props.affairautomated}
            // groupsbyyear={this.props.groupsbyyear}
            onSubmit={this.handleFilter.bind(this)}
            errorMessage={this.props.errorMessage}
          />
          <div>
            <FlatButton label="CSV Export" onClick={this.csvExport.bind(this)} />
          </div>
          <List>
          {
            this.props.message.map((option, index) => {
              //console.log(this.props.message)
              let subject;
              if (typeof option.subject !== "undefined") {
                if (option.subject.length > 0) {
                  subject = <span>
                    <span style={{color: darkBlack}}> {option.subject} </span>
                  </span>
                }
              }
              let status;
              if (typeof option.status !== "undefined") {
                if (option.status.length > 0) {
                  status = <span>
                    <span> - </span>
                    <span style={{color: darkBlack}}> {option.status} </span>
                  </span>
                }
              }
              return <ListItem
                onClick={this.handleOpen.bind(this, option.id, option.personId, option.name)}
                key={index}
                leftIcon={<AVNote />}
                /*
                rightIconButton={
                  <IconMenu iconButtonElement={iconButtonElement}>
                    <MenuItem onClick={this.handleOpen} id={option.id} >Szerkesztés</MenuItem>
                  </IconMenu>
                }
                */
                primaryText={
                  <span>
                    <span style={{color: darkBlack}}>{option.name}</span>
                    <small style={{color: lightBlack}}>
                      <span> - </span>
                      {subject}
                      {status}
                    </small>
                  </span>
                }
                />
            })

          }
          </List>
          <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
              if (this.props.message.length > 49) {
                this.props.fetchMoreMessage('/affairs', params+'&offset='+this.props.message.length+'&limit=50');
              }
            }}
          />
          <FloatingActionButton className="plusTb" style={styles.plusButton} onClick={this.handleNewOpen.bind(this, uu)} key={uu}>
            <ContentAdd />
          </FloatingActionButton>

        </div>
      )
    } else {
      return (
        <div>
          <p style={{margin: 16, textAlign: "center"}}><strong>Töltünk...</strong></p>
        </div>

      )

    }
  }
}

function mapStateToProps(state) {
  return {
    message: state.auth.message,
    affaircategories: state.tb.affaircategories,
    affairstatus: state.tb.affairstatus,
    affairautomated: state.tb.affairautomated,
    thisaffair: state.tb.thisaffair,
    editedaffair: state.tb.editedaffair,
    tracker: state.form.tbform,
    autocomplete: state.tb.autocomplete,
    // groupsbyyear: state.statistics.groupsbyyear,
    errorMessage: state.auth.error
  }
}

export default connect(mapStateToProps, actions)(Tb)


// WEBPACK FOOTER //
// ./src/components/tb/tb.js